import {Button, Icon, H3, TextRegular} from '@hm/fundamental'
import {mdiCheck, mdiPlaylistPlus} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import type {FeatureCatalogItem} from '../../../api/types/featuresMenu'

interface FeatureStoreRowProps {
  feature: FeatureCatalogItem
  isAdded: boolean
  onAddFeature: (feature: FeatureCatalogItem) => void
}

export const FeatureStoreRow: React.FC<FeatureStoreRowProps> = ({
  feature,
  isAdded,
  onAddFeature
}) => {
  const {t} = useTranslation()

  const featureName = t(`suite.featureName.${feature.name}`, {
    defaultValue: feature.name
  })
  const featureDescription = t(`suite.featureDescription.${feature.name}`, {
    defaultValue: `${feature.name} description`
  })

  return (
    <div
      className="rounded-lg border border-border_subtle bg-background px-4 py-4"
      data-cy={`feature_store_row_${feature.id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className={isAdded ? 'text-foreground_faded' : 'text-foreground'}>
          <H3>{featureName}</H3>
        </div>
        {isAdded ? (
          <div
            className="flex items-center gap-2 text-foreground_faded px-3"
            data-cy={`feature_store_added_${feature.id}`}
          >
            <Icon path={mdiCheck} size="regular" />
            <TextRegular>{t('suite.featureStore.alreadyAdded')}</TextRegular>
          </div>
        ) : (
          <Button
            variant="tertiary"
            icon={mdiPlaylistPlus}
            iconPosition="left"
            className="border-0 bg-transparent text-blue-600 hover:bg-transparent hover:text-blue-700"
            onClick={() => onAddFeature(feature)}
            data-cy={`feature_store_add_${feature.id}`}
          >
            {t('suite.featureStore.add')}
          </Button>
        )}
      </div>
      {!isAdded ? (
        <div className="mt-3">
          <TextRegular className="text-foreground">{featureDescription}</TextRegular>
        </div>
      ) : null}
    </div>
  )
}
